/* eslint-disable */
import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import homeBanner1x from 'images/Home-banner-1x.png';
import homeBanner2x from 'images/Home-banner-2x.png';


const StyledContainer = styled('div')`
  background-image: image-set(
    url(${homeBanner1x}) 1x,
    url(${homeBanner2x}) 2x
  );
  height: 380px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100% 101%;
  position: relative;

  @media only screen and (min-width: 390px) {
    height: 360px;
  }

  @media only screen and (min-width: 740px) {
    height: 435px;
  }

  @media only screen and (min-width: 767px) {
    height: 470px; 
  }
  
  @media only screen and (min-width: 878px) {
    height: 510px; 
  }

  @media only screen and (min-width: 1024px) {
    height: 590px;
  }

  @media only screen and (min-width: 1180px) {
    height: 600px;
  }

  @media only screen and (min-width: 1200px) {
    height: 700px;
  }
`

const Banner = ({ alt, children, src }) => {
  const [winHeight, setWinHeight] = useState('auto')

  useEffect(() => {
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  const handleResize = () => {
    setWinHeight(window.innerHeight * 0.01)
  }

  return <StyledContainer src={src}>{children}</StyledContainer>
}

Banner.propTypes = {
  alt: PropTypes.string,
  children: PropTypes.any,
  src: PropTypes.string.isRequired,
}

Banner.defaultProps = {
  alt: 'Banner Image',
}

export default Banner
